import React from 'react';
import { useIjrrDownload } from '../../hooks/useIjrrDownload';

interface DownloadCardProps {
  download: any;
  userEmail?: string;
}

function summarizeError(message: string): string {
  if (!message) return 'An error occurred';
  let summary = message.split('\n')[0];
  summary = summary.replace(/\/[^\s]+/g, '[path]');
  return summary;
}

export default function DownloadCard({
  download,
  userEmail,
}: DownloadCardProps) {
  const isMcap = download.format === 'BASH_SCRIPT_MCAP';

  const { handleBashScript } = useIjrrDownload({
    selected: download.selected || {},
    userEmail,
    format: isMcap ? 'MCAP' : 'IJRR',
  });

  // IJRR, BASH_SCRIPT, and BASH_SCRIPT_MCAP are all re-downloadable via bash script
  const isIjrrLike =
    download.format === 'IJRR' ||
    download.format === 'BASH_SCRIPT' ||
    download.format === 'BASH_SCRIPT_MCAP';

  return (
    <li className="p-4 border rounded shadow-sm">
      <p>
        <strong>Format:</strong> {download.format}
      </p>

      {(download.status === 'error' ||
        download.status === 'aborted' ||
        download.status === 'cancelled') && (
        <p>
          <strong>Status:</strong> {download.status}
        </p>
      )}

      <p>
        <strong>Downloaded At:</strong>{' '}
        {download.downloadedAt
          ? new Date(download.downloadedAt).toLocaleString()
          : 'N/A'}
      </p>

      {download.errorMessage && (
        <p className="text-red-500">
          <strong>Error:</strong> {summarizeError(download.errorMessage)}
        </p>
      )}

      {download.selected && Object.keys(download.selected).length > 0 && (
        <div className="mt-2">
          <strong>Selected:</strong>
          <ul className="ml-4 list-disc">
            {Object.entries(download.selected).map(([key, values]) => (
              <li key={key}>
                <span className="font-semibold">{key}:</span>{' '}
                {(values as string[]).join(', ')}
              </li>
            ))}
          </ul>
        </div>
      )}

      {isIjrrLike && (
        <div className="text-center pt-4">
          <button
            onClick={handleBashScript}
            className="bg-blue-600 text-white font-semibold px-6 py-2 rounded shadow hover:bg-blue-700 transition"
          >
            Download Again
          </button>
        </div>
      )}
    </li>
  );
}
